export const copyInBuffer = (text: string, fnAfterSuccessCopy: () => void): void => {
    navigator.clipboard.writeText(text).then(fnAfterSuccessCopy)
}
